import PhotoContainer from '../src/PhotoContainer';
export default PhotoContainer;
